import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {environment} from '../../../../environments/environment'

@Component({
    selector: 'app-tax-control',
    templateUrl: 'ae.tax.component.html',
    styleUrls: ['ae.tax.component.css'],
    standalone: false
})

export class AeTaxComponent implements OnInit {
  @Input() model: number
  @Output() modelChange = new EventEmitter()
  @Input() taxRate: number
  @Input() taxInclusive: boolean
  valid: null

  syncData() {
    this.modelChange.emit(+this.model)
  }

  onlyNumberValue() {
    if (this.model) {
      const changed = environment.inputOnlyNumber(this.model)
      this.model = +changed
      this.syncData()
    }
  }

  constructor() {
  }

  ngOnInit() {
  }
}
